import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputMaskDirective, RestrictInputDirective } from '@iot-platform/directives';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { PasswordFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-password-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    RestrictInputDirective,
    TranslatePipe,
    MatTooltipModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    InputMaskDirective,
    FormsModule,
    NgClass,
    NgTemplateOutlet
  ],
  templateUrl: './form-password-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormPasswordFieldComponent extends AbstractFormFieldComponent<PasswordFormField> {
  hidePassword: WritableSignal<boolean> = signal(true);

  togglePassword(): void {
    if (!this.field()?.disabled?.()) {
      this.hidePassword.update((value) => !value);
    }
  }
}
